const DeviceEvent = () => import('Views/deviceEvent/device-event');

export default[
  { path: '/device-event', component: DeviceEvent },
];



// WEBPACK FOOTER //
// ./src/router/deviceEvent.js